import Tooltip from './Tooltip';

export default Tooltip;


//////////////////
// WEBPACK FOOTER
// /Users/niko/Work/sketch/antd-pro/ant-design-pro-site/scaffold/node_modules/_rc-tooltip@3.7.0@rc-tooltip/es/index.js
// module id = 611
// module chunks = 0